import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import Theme from '@amzn/meridian/theme';
import { injectGlobal } from '@emotion/css';
import { AuthProvider } from './providers/AuthProvider';
import { SettingsProvider } from './providers/SettingsProvider';
import { NotificationProvider } from './providers/NotificationProvider';
import Router from './Router';
import createMeridianThemeTokens from './theme/meridian-theme-tokens';
import fontStacks from './theme/font-stacks';
import meridianOrangePalette from './theme/meridian-orange';
import { useTheme } from './hooks/useTheme';

injectGlobal({
  body: {
    fontFamily: fontStacks.sans,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
  },
  'h1, h2, h3, h4': {
    letterSpacing: '-0.01em',
  },
  '::selection': {
    backgroundColor: meridianOrangePalette.palette100,
    color: meridianOrangePalette.palette800,
  },
  '#root [role="img"][aria-hidden] svg': {
    transform: 'translateY(-50%) translateX(-50%) scale(0.75)',
    transformOrigin: 'center',
  },
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Theme
      palette={meridianOrangePalette}
      mode={isDarkMode ? 'dark' : 'light'}
      tokens={createMeridianThemeTokens(isDarkMode)}
    >
      <QueryClientProvider client={queryClient}>
        <SettingsProvider>
          <AuthProvider>
            <NotificationProvider>
              <BrowserRouter>
                <Router isDarkMode={isDarkMode} onToggleTheme={toggleTheme} />
              </BrowserRouter>
            </NotificationProvider>
          </AuthProvider>
        </SettingsProvider>
      </QueryClientProvider>
    </Theme>
  );
}

export default App;
